import { isAfterBookingToday } from "@shyne/shared";
import type { ApiClient, Appointment, BookRequest } from "@shyne/shared/api";
import type { uuid } from "@/interfaces";
import { apiRefusalOf, fieldActionMessage } from "./appointment-field-actions";
import { calendarDay } from "./appointment-reschedule";

type BookApi = Pick<ApiClient["appointments"], "book">;

export type Booking = Omit<BookRequest, "actingOrganization">;

export const isBookableDay = (day: Date, now: Date = new Date()): boolean => isAfterBookingToday(calendarDay(day), now);

const UNBOOKABLE_PROPERTY_MESSAGE = "You can't book at this property with this vendor.";

export function bookingRefusalMessage(error: unknown): string {
  if (apiRefusalOf(error)?.code === "not_found") return UNBOOKABLE_PROPERTY_MESSAGE;
  return fieldActionMessage(error, "Failed to book appointment");
}

export function createAppointmentBooking(api: BookApi) {
  return function book({ workOrderNotes, ...booking }: Booking, actingOrganization: uuid | null): Promise<Appointment> {
    return api.book({
      ...booking,
      ...(workOrderNotes ? { workOrderNotes } : {}),
      ...(actingOrganization ? { actingOrganization } : {}),
    });
  };
}
